/**
 * MiniApp Download Action Types
 *
 * Type definitions for the download action that mini-apps can request from the parent dashboard.
 */

/**
 * RPC method name for download action.
 * Mini-apps call: bridge.request("upside.miniapp.rpc.v1.download", params)
 */
export const DOWNLOAD_ACTION_METHOD = "upside.miniapp.rpc.v1.download" as const;

/**
 * Column definition for CSV export.
 * Defines how a data field maps to a CSV column.
 *
 * Note: exportValue formatters are not supported because functions cannot
 * be serialized over postMessage. MiniApps should send pre-formatted data.
 */
export interface ColumnDefinition {
  /**
   * Property key in the data object.
   * Supports nested properties using dot notation (e.g., "account.name").
   */
  key: string;

  /**
   * Human-readable column header in the CSV file.
   */
  header: string;
}

/**
 * Parameters for the download action.
 */
export interface DownloadActionParams {
  /**
   * Array of data objects to export to CSV.
   * The miniapp filters/prepares this data before sending.
   */
  data: unknown[];

  /**
   * Column definitions for the CSV structure.
   * Defines headers and optional formatting for each column.
   */
  columns: ColumnDefinition[];

  /**
   * Base filename (without .csv extension).
   * Will be sanitized and have .csv added automatically.
   * Example: "filtered_accounts_2026-01-15"
   */
  filename: string;
}

/**
 * Result returned on successful download.
 */
export interface DownloadActionResult {
  success: true;
  /**
   * Number of rows exported to the CSV file.
   */
  rowCount: number;
}
